// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ox-0";